import {NUMERIC_DECIMAL_SEPARATOR, NUMERIC_THOUSANDS_SEPARATOR} from '@fo/shared-types/constants';

import getStringNumberAsFloat from './getStringNumberAsFloat';

type Options = {
  maximumValue?: number;
};

const handleChange =
  (name: string, setValueCallback: (name: string, value: string | number) => void, options?: Options) =>
  (event: React.ChangeEvent<HTMLInputElement>): void => {
    const inputValue = event.target.value;
    const thousandsRegExp = new RegExp(NUMERIC_THOUSANDS_SEPARATOR, 'g');
    const valueAsInt = parseInt(inputValue.replace(thousandsRegExp, ''), 10);
    if (inputValue === '') {
      setValueCallback(name, '');
      return;
    }

    const lastInputChar = inputValue[inputValue.length - 1];
    if (lastInputChar === NUMERIC_DECIMAL_SEPARATOR && inputValue.length > 1) {
      // if it ends in a decimalSeparator, and it is not just a . or ,
      // then pass up as a . at the end of the formatted number
      const formattedValue = `${getStringNumberAsFloat(inputValue).toString()}.`;
      setValueCallback(name, formattedValue);
      return;
    }

    // Limits it to the maximumValue
    if (options?.maximumValue && valueAsInt > options?.maximumValue) {
      return;
    }

    if (Number.isNaN(parseInt(lastInputChar, 10))) {
      // ignore if it's a character that's not a number
      return;
    }

    // pass up the value as a number type
    const formattedValue = getStringNumberAsFloat(inputValue);
    setValueCallback(name, formattedValue);
  };

export default handleChange;
